
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqee6bbiHfWBwccUBw7brXhyJvOHlTe_45cBZKvpUEpuMmAMeta } from "/codebuild/output/src356839418/src/src/pages/faq.vue?macro=true";
import { default as menuDWy_45_45RwV8TOyXc9DiAs_UCiWw04s5ZgU5oN8_OYvKaAMeta } from "/codebuild/output/src356839418/src/src/pages/menu.vue?macro=true";
import { default as indexfK7ocbszqN40NHCqpYc_45kamzaDSzpSuW8XAwv2wz_ykMeta } from "/codebuild/output/src356839418/src/src/pages/index.vue?macro=true";
import { default as contacta4wHlZc70Cq653It_45JAzhtyvwOny0vg5feOVkJcHU9QMeta } from "/codebuild/output/src356839418/src/src/pages/contact.vue?macro=true";
import { default as tutorialOpN5dCyYfv1PyVlX50fGT5kkAqP2YKH2zFyDilvIUToMeta } from "/codebuild/output/src356839418/src/src/pages/tutorial.vue?macro=true";
import { default as agreement_6ohiz0dNIxOcu0MnPr5i55MCrOyPtpD7l6WKApTveMMeta } from "/codebuild/output/src356839418/src/src/pages/agreement.vue?macro=true";
import { default as about_45passfRAEunlS7Mh_45qzpMIt_45xD9la2Cq70ZVUtyyfhMqJrh0Meta } from "/codebuild/output/src356839418/src/src/pages/about-pass.vue?macro=true";
import { default as indexoOzC1LbVvknOTIw4GLYoGtnnAn_cN6b9UGI5WeH5e84Meta } from "/codebuild/output/src356839418/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93cwqO0o3nIVsrvoH9vMzn4ZvxGnWwk9JnzqB1zE99QAQMeta } from "/codebuild/output/src356839418/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancerTJvmheeRB2WqkrK6QCF_vwyjA9xZR2bMz_45oVWTOt7UMeta } from "/codebuild/output/src356839418/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93AaWTO2BzgsjIudlrZW0aq6fpj_45wP79tObUX9ZEB7mb8Meta } from "/codebuild/output/src356839418/src/src/pages/notice/[id].vue?macro=true";
import { default as indexR9hxa0l9PjK__DSqNU9Oo_ew_YRRQjIeJP7ODwfO1sgMeta } from "/codebuild/output/src356839418/src/src/pages/coupon/index.vue?macro=true";
import { default as indexD953rFMvbZ8YRInzi0O8tvgH0iTVGN_Aybc0xxg4k90Meta } from "/codebuild/output/src356839418/src/src/pages/mypage/index.vue?macro=true";
import { default as indexD7b8h9c2x8JVnd624IwtoIYe0D3tNYUXRQEgUU1Uk0oMeta } from "/codebuild/output/src356839418/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93VqpEZ0SywIoMtw57flkfQWnFyhrk3yoX16ref7sISj0Meta } from "/codebuild/output/src356839418/src/src/pages/parking/[id].vue?macro=true";
import { default as indexLf0ACApzVRk7aA2KaRGj9C7ZhVDFKxxpdTW2CdVxeY0Meta } from "/codebuild/output/src356839418/src/src/pages/history/index.vue?macro=true";
import { default as index4mbau_459SKwzlnXNdRAq9IvJ7HShY1IzoMgIIRxyM_KIMeta } from "/codebuild/output/src356839418/src/src/pages/monthly/index.vue?macro=true";
import { default as indexLFBBtqPCGmN_3q_45KOjQIxs1pJWccmQdPLuxn0p0WVugMeta } from "/codebuild/output/src356839418/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexS358eZ2TQKO0YUvGwtwnFHTZ_bxKaWxvHAiXduM2lzQMeta } from "/codebuild/output/src356839418/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavic1SjgAdoYcRQ4wM2EtlQGSF8HH4gUZ2zsz4Gl75GngEMeta } from "/codebuild/output/src356839418/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editDmII7Kil_45VjvpKlzAvBlS_45EqTThZiVs5Gre8_K1D8fsMeta } from "/codebuild/output/src356839418/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementfqFzqHf2Q4lLukXwqII2DGnBr6or0S4Z_45pJeqS9a114Meta } from "/codebuild/output/src356839418/src/src/pages/pass-agreement.vue?macro=true";
import { default as index7I57E6_45jton96wm4cfhZoL30OcIyuB88JcjHnYaUYLcMeta } from "/codebuild/output/src356839418/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dtbeI_3MUrwc4SvOz_uAv6XqzWCAooGHo8q3qgQvsJxwMeta } from "/codebuild/output/src356839418/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmAhZNCRmwLFmzcbbvuemLsugT_451PIuoQaPNl2OUkI7tsMeta } from "/codebuild/output/src356839418/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexae0VPJ47TbihUhkqrZE_aLG_45_459OQTl8SuHRQti21NeEMeta } from "/codebuild/output/src356839418/src/src/pages/card/create/index.vue?macro=true";
import { default as indexDxrddIxy_tSN8ZRpVR1K6cUNlCftRWLFKI_45siIkaW_454Meta } from "/codebuild/output/src356839418/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmrTjn2MdmmQM2wQIOSxwgaLNYq6Uabg6TEN8I3k6omNgMeta } from "/codebuild/output/src356839418/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmg9bZlv52f07j2w0v4KFps4u52nIXUH_45sydbakjHgwNkMeta } from "/codebuild/output/src356839418/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completedwk1EO0KLAnYUCO2orx72bRAqpEw5LRMlIDXO_yfEnkMeta } from "/codebuild/output/src356839418/src/src/pages/membership/complete.vue?macro=true";
import { default as registerOrbIK9ARAPGIy1WmxaWpZaFt655_454XHb_08QgCZEQ5oMeta } from "/codebuild/output/src356839418/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93hmDFo_450xlV_198wLwRhFv528uLMzXT_45Yuwm_VrRqXJcMeta } from "/codebuild/output/src356839418/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmnZaQn2FTIx2qkoKlAkMW_alh7XJyEbTt_J1qE546a_YMeta } from "/codebuild/output/src356839418/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93zvWRGaGi0DmfkMDgsCkGZuBIV2ZdNIbvAR0AVlxW3CQMeta } from "/codebuild/output/src356839418/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexwga5xktJ_5mi4DWu0_45LGO2enhs2k4ub5j0CXDTvD3B4Meta } from "/codebuild/output/src356839418/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeOpb53o1fCjJ_J67xB_SSIeHxyjyTHaA2EDKb4SCQbO4Meta } from "/codebuild/output/src356839418/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codemh1m3225Hakgk2d_455APHctSoWjJoknlkpY0uSw6Gs9UMeta } from "/codebuild/output/src356839418/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeSbApJpKOH9Jf61ufu7tpjnIv2ndTyyp9ndVvb2boQNcMeta } from "/codebuild/output/src356839418/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerWEf8UgkcOqha5soc_wYT5_aODF_zZxpPKCXfGBmVHOEMeta } from "/codebuild/output/src356839418/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeJIeW9gQfxNFCj4bVzpKRlo9jpdTRP70FjPrhh_lXcW8Meta } from "/codebuild/output/src356839418/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexB0RUBQWcR18zX4wL8xvH3NC7_45bDsyCpBtXJtS3wTQBoMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmZ7C8cujkKmZFhkWJfnAiiaDUm_6ctEIUokUNTxljN08Meta } from "/codebuild/output/src356839418/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeb2W16vXwpBs2FNhr2mGtFZRbELo9iIMwHV7N4ID1eIgMeta } from "/codebuild/output/src356839418/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexCdLH6HN83gnyHg64o8tRVsladiVmmcqGYRKmb4PBXc0Meta } from "/codebuild/output/src356839418/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93nA1L_T8LIRnhaW99ucy1vnXldIJqiQAeFRBj1TcVpxEMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completebeZFXUpKA3koWmf_45zgiQu5QJLS2bpXULPyYeWKoQa_45cMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasxVjgOH7BxSBXEBo_45NM50CM2NXz53OK_45Q_BJwWC0W8mUMeta } from "/codebuild/output/src356839418/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampletl580v4nbnJBsj9AZUhBpBipHHAMiBjcbh0jzdVgpO8Meta } from "/codebuild/output/src356839418/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emaile5qg9XbTmT9NjLYvCDJNodhtQuS8VosH6576AfzPgC8Meta } from "/codebuild/output/src356839418/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmYF_45bnTQ_FmgSEiHLG1o_ZVuYZ7eYCWMo_45jNmbKOKUnYMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consenttalBjpESP9_45xOYNqjESSeQOta_45OI6OuHmn1nycp4mTsMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmHGipoftLCwhFIj4qxsqvwPY0qbNitpzJFOb2UbY3TXkMeta } from "/codebuild/output/src356839418/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatez4JxRjDFNforAdDO2XZk5xhqu6YN8ajl_45fcM6Qjnb_45EMeta } from "/codebuild/output/src356839418/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completePsHNsVvP2xBkSQ4i_TOb5jQB72chYa_MDIq9fI_45KZtQMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code4o4R8IQjwnD6_8m_45o7WbPGb9M1Y0_45Gsm0j7OSXsFOnwMeta } from "/codebuild/output/src356839418/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password5ndwg5ZjMd3ndxuO_45fXRzqvDUjusNy4HguP6KxAAJ5sMeta } from "/codebuild/output/src356839418/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasnM2ovsKeK2UxPmr4lamvM94Fp7NUcsheF_45shTcFVY_oMeta } from "/codebuild/output/src356839418/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register5OUfa5dYsWm8OsFs5eIvlYL4_PVqI30qSN8mlbaGhEcMeta } from "/codebuild/output/src356839418/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeOQq8NdQcyqmQdBXO6K_45RG6ojJJk_45_DEj312uHlnqjbUMeta } from "/codebuild/output/src356839418/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexiZcG13zeWUYPEYCjBF1zVe8jJOnGanEef6xNhrUhdSoMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexRli7KEd3ZV4FGT5XWD5DbLWDMleWuyxgJuOMgBBX_CsMeta } from "/codebuild/output/src356839418/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexUU5AHKaesx3cxsuOI2BF_45v74FCxNM2shlxTuz9epzGoMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexfSY8aZOHIdIRi8LCxQcw0qBPpi7wSusYyLODWb1CT18Meta } from "/codebuild/output/src356839418/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateni3RyvHQaEGAYuh_7bb1MUgsqCgtF1V77OfdBBMIiGMMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeGhHpAfUG1j484xJapjmPxnF6nUlQNibh0L0s_45xM_daEMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm8zGqv_GlV5nzqPHK5IRqSOZSKxYun3H3lNvgqV_45VBccMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexcNXkqSLRYN0sEUgYFyc3oX6XiY6nifitlJUIdRZwxgMMeta } from "/codebuild/output/src356839418/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeyEEypqhaa5ff2MInkssfppSHktZmQj_RMrxsWC2y_WQMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatetJd36iLUYY6m5FIU6bMgv4mFYjtxjMvp72v946UURBIMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexUVE0BeWCO7Ds5Cl2ZwKRNKLnMLU4Op68zwYV2ezuz30Meta } from "/codebuild/output/src356839418/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexBnbYrMtCh9EUePkF_45oy1LTvWMEaqxrYsGCJc4hpI7xcMeta } from "/codebuild/output/src356839418/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeEdRaEOiH_B9gzlTIPktmwGKaS5dj1n64MZf2YVGZuzAMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexjYHF2IbewBOL8oHRX9iudjKaNS0_bq8vYsp4kwrK9zMMeta } from "/codebuild/output/src356839418/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45coderPCaD_45muC2SvPFA0RospzJBL_JPvHPcoLiOsC9TEAh4Meta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexngUjPwwWoZP_451AJAOeb2uvMQtPgaZeAjstSooiNKeqAMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexqOFld9yO3rzYBbwEBEkefALoKiOWYZ_45wLJCt40uGsk4Meta } from "/codebuild/output/src356839418/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indextmcovZBBS_ZZjVyHXtFFZuM7MLQJpf6bK1N9We7eTeEMeta } from "/codebuild/output/src356839418/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatep98YydavqsWbJAoYXgSLaL1UT00TqIKPR9TZWMnar40Meta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmSqgzrVjZ_45bBgovJk4fJT7ta3nRLcOlfXB2B1InChD6MMeta } from "/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src356839418/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuDWy_45_45RwV8TOyXc9DiAs_UCiWw04s5ZgU5oN8_OYvKaAMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexfK7ocbszqN40NHCqpYc_45kamzaDSzpSuW8XAwv2wz_ykMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src356839418/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src356839418/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src356839418/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src356839418/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src356839418/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexR9hxa0l9PjK__DSqNU9Oo_ew_YRRQjIeJP7ODwfO1sgMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src356839418/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src356839418/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexLf0ACApzVRk7aA2KaRGj9C7ZhVDFKxxpdTW2CdVxeY0Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexLFBBtqPCGmN_3q_45KOjQIxs1pJWccmQdPLuxn0p0WVugMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexS358eZ2TQKO0YUvGwtwnFHTZ_bxKaWxvHAiXduM2lzQMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src356839418/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src356839418/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexae0VPJ47TbihUhkqrZE_aLG_45_459OQTl8SuHRQti21NeEMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmrTjn2MdmmQM2wQIOSxwgaLNYq6Uabg6TEN8I3k6omNgMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmg9bZlv52f07j2w0v4KFps4u52nIXUH_45sydbakjHgwNkMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completedwk1EO0KLAnYUCO2orx72bRAqpEw5LRMlIDXO_yfEnkMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerOrbIK9ARAPGIy1WmxaWpZaFt655_454XHb_08QgCZEQ5oMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmnZaQn2FTIx2qkoKlAkMW_alh7XJyEbTt_J1qE546a_YMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeOpb53o1fCjJ_J67xB_SSIeHxyjyTHaA2EDKb4SCQbO4Meta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codemh1m3225Hakgk2d_455APHctSoWjJoknlkpY0uSw6Gs9UMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeSbApJpKOH9Jf61ufu7tpjnIv2ndTyyp9ndVvb2boQNcMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerWEf8UgkcOqha5soc_wYT5_aODF_zZxpPKCXfGBmVHOEMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmZ7C8cujkKmZFhkWJfnAiiaDUm_6ctEIUokUNTxljN08Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeb2W16vXwpBs2FNhr2mGtFZRbELo9iIMwHV7N4ID1eIgMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexCdLH6HN83gnyHg64o8tRVsladiVmmcqGYRKmb4PBXc0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completebeZFXUpKA3koWmf_45zgiQu5QJLS2bpXULPyYeWKoQa_45cMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampletl580v4nbnJBsj9AZUhBpBipHHAMiBjcbh0jzdVgpO8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emaile5qg9XbTmT9NjLYvCDJNodhtQuS8VosH6576AfzPgC8Meta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmYF_45bnTQ_FmgSEiHLG1o_ZVuYZ7eYCWMo_45jNmbKOKUnYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consenttalBjpESP9_45xOYNqjESSeQOta_45OI6OuHmn1nycp4mTsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmHGipoftLCwhFIj4qxsqvwPY0qbNitpzJFOb2UbY3TXkMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completePsHNsVvP2xBkSQ4i_TOb5jQB72chYa_MDIq9fI_45KZtQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code4o4R8IQjwnD6_8m_45o7WbPGb9M1Y0_45Gsm0j7OSXsFOnwMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password5ndwg5ZjMd3ndxuO_45fXRzqvDUjusNy4HguP6KxAAJ5sMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src356839418/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register5OUfa5dYsWm8OsFs5eIvlYL4_PVqI30qSN8mlbaGhEcMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeOQq8NdQcyqmQdBXO6K_45RG6ojJJk_45_DEj312uHlnqjbUMeta || {},
    component: () => import("/codebuild/output/src356839418/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src356839418/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src356839418/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]